import { Suspense, useEffect } from "react";
import {
  Route,
  Routes,
  Navigate,
  Outlet,
  Link,
  useLocation,
} from "react-router-dom";
import { Loading } from "./UI/Loading";
import { observer, inject } from "mobx-react";
import {
  Login,
  Main,
  SupportCalls,
  SupportCallsMobile,
  SupportCall,
  NewSupportCall,
  TasksMain,
  NewTask,
  ScreenType,
  Task,
  Customers,
  NewConnection,
} from "./pages";
import { useMobile } from "./utils/mobile";
import ReportDetailsMain from "./pages/ReportDetailsMain";
import ReportDetailMobile from "./pages/ReportDetailMobile";
import MonthReportsMain from "./pages/MonthReportsMain";
import Expense from "./pages/Expense";
import UpdateMonthReportMobile from "./pages/UpdateMonthReportMobile";

const ProtectedRoute = ({ isAllowed, redirectPath = "/login", children }) => {
  const location = useLocation();

  useEffect(() => {
    if (!isAllowed) {
      sessionStorage.setItem("redirectAfterLogin", location.pathname);
      sessionStorage.setItem("redirectAfterLoginParams", location.search);
    }
  }, [isAllowed, location]);

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

const AppRoutes = ({ userStore }) => {
  const isMobile = useMobile();
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route
          element={<ProtectedRoute isAllowed={userStore.isAuthenticated} />}>
          <Route element={<Main />}>
            <Route
              exact
              path="/support_calls"
              element={isMobile ? <SupportCallsMobile /> : <SupportCalls />}
            />
            <Route
              exact
              path="/new_support_call"
              element={<NewSupportCall />}
            />
            <Route exact path="/support_call" element={<SupportCall />} />
            <Route
              element={
                <ProtectedRoute isAllowed={userStore.isCoralisEmployee} />
              }>
              <Route
                exact
                path="/report_details"
                element={<ReportDetailsMain />}
              />
              <Route path="/report_detail">
                <Route index element={<ReportDetailMobile />} />
                <Route path=":itemId" element={<ReportDetailMobile />} />
              </Route>
              <Route
                exact
                path="/month_reports"
                element={<MonthReportsMain />}
              />
              <Route
                exact
                path="/update_report"
                element={<UpdateMonthReportMobile />}
              />
              <Route exact path="/expense" element={<Expense />} />
              <Route exact path="/tasks" element={<TasksMain />} />
              <Route exact path="/new_task" element={<NewTask />} />
              <Route exact path="/task" element={<Task />} />
              <Route exact path="/customers">
                <Route index element={<Customers />} />
                <Route path=":custId" element={<Customers />} />
              </Route>
              <Route exact path="/new_connection">
                <Route index element={<NewConnection />} />
                <Route path=":custId" element={<NewConnection />} />
              </Route>
              <Route path="/task">
                <Route index element={<Task />} />
                <Route path=":itemId" element={<Task />} />
              </Route>
            </Route>
            <Route path="/support_call">
              <Route index element={<SupportCall />} />
              <Route path=":itemId" element={<SupportCall />} />
            </Route>
            <Route path="*" element={<Navigate from="*" to="/login" />} />
          </Route>
        </Route>
        <Route
          exact
          key="login"
          path="/login"
          element={<Login type={ScreenType.LOGIN} />}
        />
        <Route
          exact
          key="forgot_password"
          path="/forgot_password"
          element={<Login type={ScreenType.FORGOT_PASSWORD} />}
        />
        <Route
          exact
          key="new_password"
          path="/new_password"
          element={<Login type={ScreenType.NEW_PASSWORD} />}
        />
        <Route path="/" element={<Navigate from="/" to="/login" />} />
        <Route path="*" element={<Navigate from="*" to="/login" />} />
      </Routes>

      <Link to={"/new_support_call"} style={{ display: "none" }}>
        linkToNewSupportCall
      </Link>
      <Link to={"/support_calls"} style={{ display: "none" }}>
        linkToSupportCalls
      </Link>
      <Link to={"/report_details"} style={{ display: "none" }}>
        linkToReportDetails
      </Link>
      <Link to={"/month_reports"} style={{ display: "none" }}>
        linkToMonthReportsDetails
      </Link>
      <Link to={"/tasks"} style={{ display: "none" }}>
        linkToTasks
      </Link>
      <Link to={"/task"} style={{ display: "none" }}>
        linkToTask
      </Link>
      <Link to={"/support_call"} style={{ display: "none" }}>
        linkToSupportCall
      </Link>
      <Link to={"/new_task"} style={{ display: "none" }}>
        linkToNewTask
      </Link>
      <Link to={"/customers"} style={{ display: "none" }}>
        linkToCustomers
      </Link>
      <Link to={"/new_password"} style={{ display: "none" }}>
        linkToNewPassword
      </Link>
      <Link to={"/forgot_password"} style={{ display: "none" }}>
        linkToForgotPassword
      </Link>
      <Link to={"/login"} style={{ display: "none" }}>
        linkToLogin
      </Link>
      <Link to={"/update_report"} style={{ display: "none" }}>
        linkToUpdateReport
      </Link>
      <Link to={"/new_connection"} style={{ display: "none" }}>
        linkToNewConnection
      </Link>
      <Link to={"/expense"} style={{ display: "none" }}>
        linkToExpense
      </Link>
      <Link to={"/report_detail"} style={{ display: "none" }}>
        linkToReportDetail
      </Link>
    </Suspense>
  );
};

export default inject("userStore")(observer(AppRoutes));
